import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const hasRejectedTailorings = api(async function hasRejectedTailorings(referenceId, version) {
    if (version === 0) return false
    return query(
        gql`
            query HasRejectedTailorings($referenceId: String, $version: Int) {
                hasRejectedTailorings(referenceId: $referenceId, version: $version)
            }
        `,
        { referenceId, version },
        {
            returns: "hasRejectedTailorings",
        }
    )
})
